import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { RgiScholarshipComponent } from './rgi-scholarship/rgi-scholarship.component';
import { EventsComponent } from './events/events.component';
import { CompetitionComponent } from './competition/competition.component';
import { GalleryComponent } from './gallery/gallery.component';
import { MediaComponent } from './media/media.component';
import { ClubComponent } from './club/club.component';
import { ResultComponent } from './result/result.component';
import { SportEventsComponent } from './sport-events/sport-events.component';
import { CulturalEventsComponent } from './cultural-events/cultural-events.component';
import { PhotogalleryComponent } from './photogallery/photogallery.component';
import { VideogalleryComponent } from './videogallery/videogallery.component';
import { RaagasUrvashiComponent } from './raagas-urvashi/raagas-urvashi.component';
import { EmployeeSportMeetComponent } from './employee-sport-meet/employee-sport-meet.component';
import { SummerCampComponent } from './summer-camp/summer-camp.component';
import { EmployeeSportsComponent } from './employee-sports/employee-sports.component';
import { KiteFestivalComponent } from './kite-festival/kite-festival.component';
import { ChessFestComponent } from './chess-fest/chess-fest.component';
import { ItoolovemynationComponent } from './itoolovemynation/itoolovemynation.component';
import { FidechessGalleryComponent } from './fidechess-gallery/fidechess-gallery.component';
import { KiteFestivalGalleryComponent } from './kite-festival-gallery/kite-festival-gallery.component';
import { SjanAwardGalleryComponent } from './sjan-award-gallery/sjan-award-gallery.component';
import { DhamaalDandiyaYearlyComponent } from './dhamaal-dandiya-yearly/dhamaal-dandiya-yearly.component';
import { ContactComponent } from './contact/contact.component';
import { ItoohavetalentComponent } from './itoohavetalent/itoohavetalent.component';
import { RapidChessTournamentComponent } from './rapid-chess-tournament/rapid-chess-tournament.component';
import { ChessCompetitionComponent } from './chess-competition/chess-competition.component';
import { DhamaalDandiyaYear2019Component } from './dhamaal-dandiya-year2019/dhamaal-dandiya-year2019.component';
import { DhamaalDandiyaYear2018Component } from './dhamaal-dandiya-year2018/dhamaal-dandiya-year2018.component';
import { DhamaalDandiyaYear2017Component } from './dhamaal-dandiya-year2017/dhamaal-dandiya-year2017.component';
import { DhamaalDandiyaYear2016Component } from './dhamaal-dandiya-year2016/dhamaal-dandiya-year2016.component';
import { DhamaalDandiyaYear2015Component } from './dhamaal-dandiya-year2015/dhamaal-dandiya-year2015.component';
import { PubgComponent } from './pubg/pubg.component';
import { RaisoniPremierLeagueComponent } from './raisoni-premier-league/raisoni-premier-league.component';
import { BadmintonSeriesComponent } from './badminton-series/badminton-series.component';
import { NationalFederationComponent } from './national-federation/national-federation.component';
import { ClassicConclaveComponent } from './classic-conclave/classic-conclave.component';
import { LataMangeshkarComponent } from './lata-mangeshkar/lata-mangeshkar.component';
import { FideChesscompetitionComponent } from './fide-chesscompetition/fide-chesscompetition.component';
import { ArvindUpadhyeComponent } from './arvind-upadhye/arvind-upadhye.component';
import { KalyaniDeshpandeComponent } from './kalyani-deshpande/kalyani-deshpande.component';
import { HrishikeshKarmarkarComponent } from './hrishikesh-karmarkar/hrishikesh-karmarkar.component';
import { OnlineRahulJoshiComponent } from './online-rahul-joshi/online-rahul-joshi.component';
import { OnlineSadhanaShiledarComponent } from './online-sadhana-shiledar/online-sadhana-shiledar.component';
import { OnlineBhupaalPanshikarComponent } from './online-bhupaal-panshikar/online-bhupaal-panshikar.component';
import { VivekBansodComponent } from './vivek-bansod/vivek-bansod.component';
import { SwarRangComponent } from './swar-rang/swar-rang.component';
import { SjanAwardComponent } from './sjan-award/sjan-award.component';
import { KonkanKanyaComponent } from './konkan-kanya/konkan-kanya.component';
import { GaneshaUtsavaComponent } from './ganesha-utsava/ganesha-utsava.component';
import { ShivajiMahotsavComponent } from './shivaji-mahotsav/shivaji-mahotsav.component';
import { DanceCityDanceComponent } from './dance-city-dance/dance-city-dance.component';
import { FlashMobComponent } from './flash-mob/flash-mob.component';
import { DhamaalDandiyaComponent } from './dhamaal-dandiya/dhamaal-dandiya.component';
import { FideChess2021Component } from './fide-chess2021/fide-chess2021.component';
import { FideChess2019Component } from './fide-chess2019/fide-chess2019.component';
import { FideChess2018Component } from './fide-chess2018/fide-chess2018.component';
import { DevakiPanditComponent } from './devaki-pandit/devaki-pandit.component';
import { AditiUpadhyaComponent } from './aditi-upadhya/aditi-upadhya.component';
import { PrasadKhapardeComponent } from './prasad-khaparde/prasad-khaparde.component';
import { ManjushaPatilComponent } from './manjusha-patil/manjusha-patil.component';
import { VidushiComponent } from './vidushi/vidushi.component';
import { UrvashiShahComponent } from './urvashi-shah/urvashi-shah.component';
import { BhupaalPanshikarComponent } from './bhupaal-panshikar/bhupaal-panshikar.component';
import { KakoliComponent } from './kakoli/kakoli.component';
import { PriyankaComponent } from './priyanka/priyanka.component';
import { ManbhavanComponent } from './manbhavan/manbhavan.component';
import { NiraliKartikComponent } from './nirali-kartik/nirali-kartik.component';
import { JugalbandiComponent } from './jugalbandi/jugalbandi.component';
import { RegisterSummerCampComponent } from './register-summer-camp/register-summer-camp.component';
import { AssociationComponent } from './association/association.component';
import { RumiHaiComponent } from './rumi-hai/rumi-hai.component';
import { SawaniSathayeComponent } from './sawani-sathaye/sawani-sathaye.component';
import { KonkanKanyaRegistartionComponent } from './konkan-kanya-registartion/konkan-kanya-registartion.component';
import { MelvinLouiseComponent } from './melvin-louise/melvin-louise.component';
import { RegisterMelvinLouiseComponent } from './register-melvin-louise/register-melvin-louise.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { MusicalCompComponent } from './musical-comp/musical-comp.component';
import { ShootsightCompComponent } from './shootsight-comp/shootsight-comp.component';
import { StepupComponent } from './stepup/stepup.component';
import { DressDesignComponent } from './dress-design/dress-design.component';
import { NaadNinaadComponent } from './naad-ninaad/naad-ninaad.component';
import { Itoohavetalent22Component } from './itoohavetalent22/itoohavetalent22.component';
import { EmployeeSportTwentyThreeComponent } from './employee-sport-twenty-three/employee-sport-twenty-three.component';
import { HarshitaGautamComponent } from './harshita-gautam/harshita-gautam.component';
import { PgRedirectComponent } from './pg-redirect/pg-redirect.component';
import { PgResponseComponent } from './pg-response/pg-response.component';
import { ViewharshitaGautamComponent } from './viewharshita-gautam/viewharshita-gautam.component';
import { ChessTournament23Component } from './chess-tournament23/chess-tournament23.component';
import { RegisterLataMangeshkarWardhaComponent } from './register-lata-mangeshkar-wardha/register-lata-mangeshkar-wardha.component';
import { ChessTournamentBhandaraComponent } from './chess-tournament-bhandara/chess-tournament-bhandara.component';
import { NrutyavishkarComponent } from './nrutyavishkar/nrutyavishkar.component';
import { LataMageshkarWardhaEventComponent } from './lata-mageshkar-wardha-event/lata-mageshkar-wardha-event.component';
import { LataMageshkarChandrapurEventComponent } from './lata-mageshkar-chandrapur-event/lata-mageshkar-chandrapur-event.component';
import { MusicalRejuvenationComponent } from './musical-rejuvenation/musical-rejuvenation.component';
import { SanjeevAbhyankarAmravatiComponent } from './sanjeev-abhyankar-amravati/sanjeev-abhyankar-amravati.component';
import { SanjeevAbhyankarNagpurComponent } from './sanjeev-abhyankar-nagpur/sanjeev-abhyankar-nagpur.component';
import { LataMageshkarBhandaraEventComponent } from './lata-mageshkar-bhandara-event/lata-mageshkar-bhandara-event.component';
import { UnforgettableKkComponent } from './unforgettable-kk/unforgettable-kk.component';
import { SupportEncouragementComponent } from './support-encouragement/support-encouragement.component';
import { SlumSoccerComponent } from './slum-soccer/slum-soccer.component';
import { RegisterUnforgettableKkComponent } from './register-unforgettable-kk/register-unforgettable-kk.component';
import { FideChess2023Component } from './fide-chess2023/fide-chess2023.component';
import { ChessChampionship2023Component } from './chess-championship2023/chess-championship2023.component';
import { RegisterDanceEventComponent } from './register-dance-event/register-dance-event.component';
import { MemorialCupComponent } from './memorial-cup/memorial-cup.component';
import { RegisterClassicalVocalNagpurComponent } from './register-classical-vocal-nagpur/register-classical-vocal-nagpur.component';
import { RegisterClassicalVocalAmtComponent } from './register-classical-vocal-amt/register-classical-vocal-amt.component';
import { SiyavrRamComponent } from './siyavr-ram/siyavr-ram.component';
import { RegisterMemorialArcheryTournamentComponent } from './register-memorial-archery-tournament/register-memorial-archery-tournament.component';
import { LataMangeshkarAkolaEventComponent } from './lata-mangeshkar-akola-event/lata-mangeshkar-akola-event.component';
import { RegisterLataMangeshkarAkolaComponent } from './register-lata-mangeshkar-akola/register-lata-mangeshkar-akola.component';
import { RegisterLataMangeshkarYavatmalComponent } from './register-lata-mangeshkar-yavatmal/register-lata-mangeshkar-yavatmal.component';
import { NagpurDistrictUnderEllevenTournamentComponent } from './nagpur-district-under-elleven-tournament/nagpur-district-under-elleven-tournament.component';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { BasketballChampionshipComponent } from './basketball-championship/basketball-championship.component';
import { RegisterLataMangeshkarChhindwaraComponent } from './register-lata-mangeshkar-chhindwara/register-lata-mangeshkar-chhindwara.component';
import { LataMangeshkarBetulEventComponent } from './lata-mangeshkar-betul-event/lata-mangeshkar-betul-event.component';
import { RegisterLataMangeshkarBetulComponent } from './register-lata-mangeshkar-betul/register-lata-mangeshkar-betul.component';
import { LataMangeshkarChhindwaraEventComponent } from './lata-mangeshkar-chhindwara-event/lata-mangeshkar-chhindwara-event.component';
import { BadmintonTournamentComponent } from './badminton-tournament/badminton-tournament.component';
import { FideRatingChess2023Component } from './fide-rating-chess2023/fide-rating-chess2023.component';
import { FideRatingChessTournamentComponent } from './fide-rating-chess-tournament/fide-rating-chess-tournament.component';
import { ArcheryTournamentPuneComponent } from './archery-tournament-pune/archery-tournament-pune.component';
import { ArcheryTournamentNagpurComponent } from './archery-tournament-nagpur/archery-tournament-nagpur.component';
import { ArcheryTournamentAmravatiComponent } from './archery-tournament-amravati/archery-tournament-amravati.component';
import { RegistrationAnkalikarComponent } from './registration-ankalikar/registration-ankalikar.component';
import { VidushiAartiAnkalikarComponent } from './vidushi-aarti-ankalikar/vidushi-aarti-ankalikar.component';
import { FutsalTournamentComponent } from './futsal-tournament/futsal-tournament.component';
import { LataMangeshkarYavatmalEventComponent } from './lata-mangeshkar-yavatmal-event/lata-mangeshkar-yavatmal-event.component';
import { TableTennisAmravatiComponent } from './table-tennis-amravati/table-tennis-amravati.component';
import { NationalFederationOfBlindComponent } from './national-federation-of-blind/national-federation-of-blind.component';
import { DhamaalDandiyaYear2023Component } from './dhamaal-dandiya-year2023/dhamaal-dandiya-year2023.component';
import { PuneInternationalChessTournamentComponent } from './pune-international-chess-tournament/pune-international-chess-tournament.component';
import { NeevEmployeeSportsMeetComponent } from './neev-employee-sports-meet/neev-employee-sports-meet.component';
import { SjanAwardTwentyfourComponent } from './sjan-award-twentyfour/sjan-award-twentyfour.component';
import { FootballTournamentComponent } from './football-tournament/football-tournament.component';
import { SwimmingCompetitionComponent } from './swimming-competition/swimming-competition.component';
import { ChessChampionshipComponent } from './chess-championship/chess-championship.component';
import { ArmsportCompetitionComponent } from './armsport-competition/armsport-competition.component';
import { FideChessAmtComponent } from './fide-chess-amt/fide-chess-amt.component';
import { SadabaiRaisoniWomensBatmintonComponent } from './sadabai-raisoni-womens-batminton/sadabai-raisoni-womens-batminton.component';
import { MendatoryDisclosureComponent } from './mendatory-disclosure/mendatory-disclosure.component';
import { SecondChessChampionshipComponent } from './second-chess-championship/second-chess-championship.component';
import { NagpurOpenGirlsChessComponent } from './nagpur-open-girls-chess/nagpur-open-girls-chess.component';
import { MemorialInternationalComponent } from './memorial-international/memorial-international.component';
import { SecondFadeRatingChessTournamentComponent } from './second-fade-rating-chess-tournament/second-fade-rating-chess-tournament.component';
import { BadmintonCompePuneComponent } from './badminton-compe-pune/badminton-compe-pune.component';
import { BadmintonCompetitionComponent } from './badminton-competition/badminton-competition.component';
import { SjanRaisoniAchieversAwardComponent } from './sjan-raisoni-achievers-award/sjan-raisoni-achievers-award.component';
import { BlitzChessChampionshipComponent } from './blitz-chess-championship/blitz-chess-championship.component';
import { BadmintonCompeVidarbhComponent } from './badminton-compe-vidarbh/badminton-compe-vidarbh.component';
import { KarandakAuditionsComponent } from './karandak-auditions/karandak-auditions.component';
import { KarandakAuditionsKolhapurComponent } from './karandak-auditions-kolhapur/karandak-auditions-kolhapur.component';
import { KarandakAuditionsPuneComponent } from './karandak-auditions-pune/karandak-auditions-pune.component';
import { KarandakAuditionsRatnagiriComponent } from './karandak-auditions-ratnagiri/karandak-auditions-ratnagiri.component';
import { PuneCheckmateChallengeComponent } from './pune-checkmate-challenge/pune-checkmate-challenge.component';
import { JhipruAndChimnayanoComponent } from './jhipru-and-chimnayano/jhipru-and-chimnayano.component';
import { YonexSunriseChandrapurComponent } from './yonex-sunrise-chandrapur/yonex-sunrise-chandrapur.component';
import { YonexSunriseVidarbhaLevalComponent } from './yonex-sunrise-vidarbha-leval/yonex-sunrise-vidarbha-leval.component';
import { CricketTournamentComponent } from './cricket-tournament/cricket-tournament.component';
import { SjanT20CricketTournamentComponent } from './sjan-t20-cricket-tournament/sjan-t20-cricket-tournament.component';
import { WomensChessComponent } from './womens-chess/womens-chess.component';
import { OpenAndGirlsSelectionChessComponent } from './open-and-girls-selection-chess/open-and-girls-selection-chess.component';
import { BadmintonChampionshipComponent } from './badminton-championship/badminton-championship.component';
import { BuldhanaDistrictBadmintonChampionshipComponent } from './buldhana-district-badminton-championship/buldhana-district-badminton-championship.component';
import { FideRapidRatingChessTournamentComponent } from './fide-rapid-rating-chess-tournament/fide-rapid-rating-chess-tournament.component';
import { MhWomensBadmintonTournamentComponent } from './mh-womens-badminton-tournament/mh-womens-badminton-tournament.component';
import { InternationalFideRapidRatingChessTournamentComponent } from './international-fide-rapid-rating-chess-tournament/international-fide-rapid-rating-chess-tournament.component';
import { BhandaraOneDayRapidChessTournamentComponent } from './bhandara-one-day-rapid-chess-tournament/bhandara-one-day-rapid-chess-tournament.component';
import { MemorialChessTournamentGondiaComponent } from './memorial-chess-tournament-gondia/memorial-chess-tournament-gondia.component';
import { ExtendedSupportComponent } from './extended-support/extended-support.component';
import { ChessChampionshipUnderSevenSeventeenComponent } from './chess-championship-under-seven-seventeen/chess-championship-under-seven-seventeen.component';
import { ChessChampionshipUnderNineNineteenComponent } from './chess-championship-under-nine-nineteen/chess-championship-under-nine-nineteen.component';
import { ChessChampionshipUnderElevenFifteenComponent } from './chess-championship-under-eleven-fifteen/chess-championship-under-eleven-fifteen.component';
import { NagpurDistrictAmateurBadmintonTournamentComponent } from './nagpur-district-amateur-badminton-tournament/nagpur-district-amateur-badminton-tournament.component';
import { BuldhanaDistrictBadmintonChampionshipTwentyFiveComponent } from './buldhana-district-badminton-championship-twenty-five/buldhana-district-badminton-championship-twenty-five.component';
import { ChessTournamentTwentyFiveComponent } from './chess-tournament-twenty-five/chess-tournament-twenty-five.component';
import { RaisoniMemorialVidarbhaLevelBadmintonTournamentComponent } from './raisoni-memorial-vidarbha-level-badminton-tournament/raisoni-memorial-vidarbha-level-badminton-tournament.component';
import { PalgharBadmintonTournamentComponent } from './palghar-badminton-tournament/palghar-badminton-tournament.component';
import { GadchiroliDistrictBadmintonChampionshipComponent } from './gadchiroli-district-badminton-championship/gadchiroli-district-badminton-championship.component';
import { MemorialChessTournamentRatnagiriComponent } from './memorial-chess-tournament-ratnagiri/memorial-chess-tournament-ratnagiri.component';
import { NagpurDistrictFirstSelectionBadmintonTournamentComponent } from './nagpur-district-first-selection-badminton-tournament/nagpur-district-first-selection-badminton-tournament.component';
import { DhuleDistBadmintonChampionshipComponent } from './dhule-dist-badminton-championship/dhule-dist-badminton-championship.component';
import { NandedDistrictChessSelectionTournamentComponent } from './nanded-district-chess-selection-tournament/nanded-district-chess-selection-tournament.component';
import { PuneDistBadmintonChampionshipComponent } from './pune-dist-badminton-championship/pune-dist-badminton-championship.component';
import { NeevTwentyFiveComponent } from './neev-twenty-five/neev-twenty-five.component';
import { TelanganaStateSeniorBadChamComponent } from './telangana-state-senior-bad-cham/telangana-state-senior-bad-cham.component';
import { ChessCompetitionPrizeDistrubutionComponent } from './chess-competition-prize-distrubution/chess-competition-prize-distrubution.component';
import { WrestlingChampionshipsTwentyFiveComponent } from './wrestling-championships-twenty-five/wrestling-championships-twenty-five.component';
import { SwaraginiComponent } from './swaragini/swaragini.component';
import { GhraisoniMemorialAmravatiDistrictBadmintonChampionshipTwentyfiveComponent } from './ghraisoni-memorial-amravati-district-badminton-championship-twentyfive/ghraisoni-memorial-amravati-district-badminton-championship-twentyfive.component';
import { AmravatiDistrictBadmintonComponent } from './amravati-district-badminton/amravati-district-badminton.component';
import { GhrMemorialPuneFideRapidRatingChessTwentyfiveComponent } from './ghr-memorial-pune-fide-rapid-rating-chess-twentyfive/ghr-memorial-pune-fide-rapid-rating-chess-twentyfive.component';
import { ChessAssociationNgpCelebratesInternationalChessDayComponent } from './chess-association-ngp-celebrates-international-chess-day/chess-association-ngp-celebrates-international-chess-day.component';
import { EkShamGeetoKeNaamComponent } from './ek-sham-geeto-ke-naam/ek-sham-geeto-ke-naam.component';
import { NagpurBelowSeventeenHundredFideRatingChessTournamentComponent } from './nagpur-below-seventeen-hundred-fide-rating-chess-tournament/nagpur-below-seventeen-hundred-fide-rating-chess-tournament.component';
import { NandedDistrictBadmintonChampionshipComponent } from './nanded-district-badminton-championship/nanded-district-badminton-championship.component';
import { GhRaisoniBadmintonUnderFifteenUnderSeventeenComponent } from './gh-raisoni-badminton-under-fifteen-under-seventeen/gh-raisoni-badminton-under-fifteen-under-seventeen.component';
import { DivisionLevelChessMeetComponent } from './division-level-chess-meet/division-level-chess-meet.component';
import { PithoraOneDayRapidChessTournamentComponent } from './pithora-one-day-rapid-chess-tournament/pithora-one-day-rapid-chess-tournament.component';
import { SargujaDivisionOneDayRapidChessTournamentComponent } from './sarguja-division-one-day-rapid-chess-tournament/sarguja-division-one-day-rapid-chess-tournament.component';
import { ThaneFideRapidChessTournamentComponent } from './thane-fide-rapid-chess-tournament/thane-fide-rapid-chess-tournament.component';
import { RapidChessTournamentConcludesComponent } from './rapid-chess-tournament-concludes/rapid-chess-tournament-concludes.component';
import { MarathwadaOpenBadmintonTournamentComponent } from './marathwada-open-badminton-tournament/marathwada-open-badminton-tournament.component';
import { RaigadDistrictLevelOneDayComponent } from './raigad-district-level-one-day/raigad-district-level-one-day.component';
import { JalnaRapidChessTournamentComponent } from './jalna-rapid-chess-tournament/jalna-rapid-chess-tournament.component';
import { NagpurChessFestivalComponent } from './nagpur-chess-festival/nagpur-chess-festival.component';
import { NeevTwentySixComponent } from './neev-twenty-six/neev-twenty-six.component';
import { AboutFoundationComponent } from './about-foundation/about-foundation.component';
import { AdvisoryBoardComponent } from './advisory-board/advisory-board.component';
import { AboutTeamComponent } from './about-team/about-team.component';
import { MissionVissionComponent } from './mission-vission/mission-vission.component';
import { ZankarLavaniComponent } from './zankar-lavani/zankar-lavani.component';
import { ChessOpenTournamentComponent } from './chess-open-tournament/chess-open-tournament.component';
import { JalnaChessTournamentComponent } from './jalna-chess-tournament/jalna-chess-tournament.component';
import { TwentyEigthNationalsChessChampionshipComponent } from './twenty-eigth-nationals-chess-championship/twenty-eigth-nationals-chess-championship.component';
import { JalnaOpenChessTournamentComponent } from './jalna-open-chess-tournament/jalna-open-chess-tournament.component';
import { NagpurDistrictChessTournamentComponent } from './nagpur-district-chess-tournament/nagpur-district-chess-tournament.component';
import { NagpurDistrictRapidBlitzChessComponent } from './nagpur-district-rapid-blitz-chess/nagpur-district-rapid-blitz-chess.component';
import { SingrauliDistrictChessTournamentComponent } from './singrauli-district-chess-tournament/singrauli-district-chess-tournament.component';
import { RatlamOpenRapidChessTournamentComponent } from './ratlam-open-rapid-chess-tournament/ratlam-open-rapid-chess-tournament.component';
import { BhandaraRapidChessComponent } from './bhandara-rapid-chess/bhandara-rapid-chess.component';
import { KhairagarhChessTournamentComponent } from './khairagarh-chess-tournament/khairagarh-chess-tournament.component';
import { PuneChessTournamentComponent } from './pune-chess-tournament/pune-chess-tournament.component';
import { GwaliorOneDayChessTournamentComponent } from './gwalior-one-day-chess-tournament/gwalior-one-day-chess-tournament.component';
import { ChessTournamentChandrapurComponent } from './chess-tournament-chandrapur/chess-tournament-chandrapur.component';
import { SambhajinagarChessTournamentComponent } from './sambhajinagar-chess-tournament/sambhajinagar-chess-tournament.component';
import { DurgDivisionalChessTournamentComponent } from './durg-divisional-chess-tournament/durg-divisional-chess-tournament.component';
import { SurajpurChessTournamentComponent } from './surajpur-chess-tournament/surajpur-chess-tournament.component';
import { AmbikapurChessTournamentComponent } from './ambikapur-chess-tournament/ambikapur-chess-tournament.component';
import { KatniFideChessTournamentComponent } from './katni-fide-chess-tournament/katni-fide-chess-tournament.component';
import { GhraisoniChessFestivalComponent } from './ghraisoni-chess-festival/ghraisoni-chess-festival.component';
import { KhargoneBadmintonComponent } from './khargone-badminton/khargone-badminton.component';
import { InternationalFideRapidRatingChessTournamentPuneComponent } from './international-fide-rapid-rating-chess-tournament-pune/international-fide-rapid-rating-chess-tournament-pune.component';
import { NandurbarChessTournamentComponent } from './nandurbar-chess-tournament/nandurbar-chess-tournament.component';
import { MaharashtraStateSubJuniorComponent } from './maharashtra-state-sub-junior/maharashtra-state-sub-junior.component';
import { YavatmalDistrictBadmintonComponent } from './yavatmal-district-badminton/yavatmal-district-badminton.component';
import { YonexNagpurDistrictComponent } from './yonex-nagpur-district/yonex-nagpur-district.component';

const routes: Routes = [
  {
    path: '', component: HomeComponent,
    data: {
      keywords: 'Home || G H Raisoni Sports & Cultural Foundation',
      description: 'Home || G H Raisoni Sports & Cultural Foundation',
      title: 'Home || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'about', component: AboutComponent,
    data: {
      keywords: 'About  || G H Raisoni Sports & Cultural Foundation',
      description: 'About  || G H Raisoni Sports & Cultural Foundation',
      title: 'About  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'rgi-scholarship', component: RgiScholarshipComponent,
    data: {
      keywords: 'Rgi Scholarship  || G H Raisoni Sports & Cultural Foundation',
      description: 'Rgi Scholarship  || G H Raisoni Sports & Cultural Foundation',
      title: 'Rgi Scholarship  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'events', component: EventsComponent,
    data: {
      keywords: 'Events  || G H Raisoni Sports & Cultural Foundation',
      description: 'Events  || G H Raisoni Sports & Cultural Foundation',
      title: 'Events  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'competition', component: CompetitionComponent,
    data: {
      keywords: 'Competition  || G H Raisoni Sports & Cultural Foundation',
      description: 'Competition  || G H Raisoni Sports & Cultural Foundation',
      title: 'Competition  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'gallery', component: GalleryComponent,
    data: {
      keywords: 'Gallery  || G H Raisoni Sports & Cultural Foundation',
      description: 'Gallery  || G H Raisoni Sports & Cultural Foundation',
      title: 'Gallery  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'media', component: MediaComponent,
    data: {
      keywords: 'Media  || G H Raisoni Sports & Cultural Foundation',
      description: 'Media  || G H Raisoni Sports & Cultural Foundation',
      title: 'Media  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'club', component: ClubComponent,
    data: {
      keywords: 'Club  || G H Raisoni Sports & Cultural Foundation',
      description: 'Club  || G H Raisoni Sports & Cultural Foundation',
      title: 'Club  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'result', component: ResultComponent,
    data: {
      keywords: 'Result  || G H Raisoni Sports & Cultural Foundation',
      description: 'Result  || G H Raisoni Sports & Cultural Foundation',
      title: 'Result  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sport-events', component: SportEventsComponent,
    data: {
      keywords: 'Sport Events  || G H Raisoni Sports & Cultural Foundation',
      description: 'Sport Events  || G H Raisoni Sports & Cultural Foundation',
      title: 'Sport Events  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'cultural-events', component: CulturalEventsComponent,
    data: {
      keywords: 'Cultural Events  || G H Raisoni Sports & Cultural Foundation',
      description: 'Cultural Events  || G H Raisoni Sports & Cultural Foundation',
      title: 'Cultural Events  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'photogallery', component: PhotogalleryComponent,
    data: {
      keywords: 'Photogallery  || G H Raisoni Sports & Cultural Foundation',
      description: 'Photogallery  || G H Raisoni Sports & Cultural Foundation',
      title: 'Photogallery  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'videogallery', component: VideogalleryComponent,
    data: {
      keywords: 'Videogallery  || G H Raisoni Sports & Cultural Foundation',
      description: 'Videogallery  || G H Raisoni Sports & Cultural Foundation',
      title: 'Videogallery  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'raagas-urvashi', component: RaagasUrvashiComponent,
    data: {
      keywords: 'Raagas Urvashi  || G H Raisoni Sports & Cultural Foundation',
      description: 'Raagas Urvashi  || G H Raisoni Sports & Cultural Foundation',
      title: 'Raagas Urvashi  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'employee-sport-meet', component: EmployeeSportMeetComponent,
    data: {
      keywords: 'Employee Sport Meet  || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport Meet  || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport Meet  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'summer-camp', component: SummerCampComponent,
    data: {
      keywords: 'summer camp ||G H Raisoni Sports & Cultural Foundation',
      description: 'summer camp ||G H Raisoni Sports & Cultural Foundation',
      title: 'summer camp ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'employee-sports', component: EmployeeSportsComponent,
    data: {
      keywords: 'employee sports ||G H Raisoni Sports & Cultural Foundation',
      description: 'employee sports ||G H Raisoni Sports & Cultural Foundation',
      title: 'employee sports ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'kite-festival', component: KiteFestivalComponent,
    data: {
      keywords: 'kite festival ||G H Raisoni Sports & Cultural Foundation',
      description: 'kite festival ||G H Raisoni Sports & Cultural Foundation',
      title: 'kite festival ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-fest', component: ChessFestComponent,
    data: {
      keywords: 'chess fest ||G H Raisoni Sports & Cultural Foundation',
      description: 'chess fest ||G H Raisoni Sports & Cultural Foundation',
      title: 'chess fest ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'itoolovemynation', component: ItoolovemynationComponent,
    data: {
      keywords: 'itoolovemynation ||G H Raisoni Sports & Cultural Foundation',
      description: 'itoolovemynation ||G H Raisoni Sports & Cultural Foundation',
      title: 'itoolovemynation ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fidechess-gallery', component: FidechessGalleryComponent,
    data: {
      keywords: 'Fidechess Gallery ||G H Raisoni Sports & Cultural Foundation',
      description: 'Fidechess Gallery ||G H Raisoni Sports & Cultural Foundation',
      title: 'Fidechess Gallery ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'kite-festival-gallery', component: KiteFestivalGalleryComponent,
    data: {
      keywords: 'Kite Festival Gallery ||G H Raisoni Sports & Cultural Foundation',
      description: 'Kite Festival Gallery ||G H Raisoni Sports & Cultural Foundation',
      title: 'Kite Festival Gallery ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sjan-award-gallery', component: SjanAwardGalleryComponent,
    data: {
      keywords: 'Sjan Award Gallery ||G H Raisoni Sports & Cultural Foundation',
      description: 'Sjan Award Gallery ||G H Raisoni Sports & Cultural Foundation',
      title: 'Sjan Award Gallery ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-yearly', component: DhamaalDandiyaYearlyComponent,
    data: {
      keywords: 'Dhamaal Dandiya Yearly ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Yearly ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Yearly ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'itoohavetalent', component: ItoohavetalentComponent,
    data: {
      keywords: 'itoohavetalent||G H Raisoni Sports & Cultural Foundation',
      description: 'itoohavetalent||G H Raisoni Sports & Cultural Foundation',
      title: 'itoohavetalent||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'rapid-chess-tournament', component: RapidChessTournamentComponent,
    data: {
      keywords: 'rapid chess tournament ||G H Raisoni Sports & Cultural Foundation',
      description: 'rapid chess tournament ||G H Raisoni Sports & Cultural Foundation',
      title: 'rapid chess tournament ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-competition', component: ChessCompetitionComponent,
    data: {
      keywords: 'chess competition ||G H Raisoni Sports & Cultural Foundation',
      description: 'chess competition ||G H Raisoni Sports & Cultural Foundation',
      title: 'chess competition ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-year2019', component: DhamaalDandiyaYear2019Component,
    data: {
      keywords: 'Dhamaal Dandiya Year 2019 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Year 2019 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Year 2019 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'contact', component: ContactComponent,
    data: {
      keywords: 'Contact ||G H Raisoni Sports & Cultural Foundation',
      description: 'Contact ||G H Raisoni Sports & Cultural Foundation',
      title: 'Contact ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-year2018', component: DhamaalDandiyaYear2018Component,
    data: {
      keywords: 'Dhamaal Dandiya Year 2018 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Year 2018 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Year 2018 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-year2017', component: DhamaalDandiyaYear2017Component,
    data: {
      keywords: 'Dhamaal Dandiya Year 2017 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Year 2017 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Year 2017 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-year2016', component: DhamaalDandiyaYear2016Component,
    data: {
      keywords: 'Dhamaal Dandiya Year 2016 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Year 2016 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Year 2016 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-year2015', component: DhamaalDandiyaYear2015Component,
    data: {
      keywords: 'Dhamaal Dandiya Year 2015 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Year 2015 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Year 2015 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pubg', component: PubgComponent,
    data: {
      keywords: 'pubg ||G H Raisoni Sports & Cultural Foundation',
      description: 'pubg ||G H Raisoni Sports & Cultural Foundation',
      title: 'pubg ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'raisoni-premier-league', component: RaisoniPremierLeagueComponent,
    data: {
      keywords: 'raisoni premier league ||G H Raisoni Sports & Cultural Foundation',
      description: 'raisoni premier league ||G H Raisoni Sports & Cultural Foundation',
      title: 'raisoni premier league ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'badminton-series', component: BadmintonSeriesComponent,
    data: {
      keywords: 'badminton series ||G H Raisoni Sports & Cultural Foundation',
      description: 'badminton series ||G H Raisoni Sports & Cultural Foundation',
      title: 'badminton series ||G H Raisoni Sports & Cultural Foundation'
    }
  },

  {
    path: 'national-federation', component: NationalFederationComponent,
    data: {
      keywords: 'national federation ||G H Raisoni Sports & Cultural Foundation',
      description: 'national federation ||G H Raisoni Sports & Cultural Foundation',
      title: 'national federation ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'classic-conclave', component: ClassicConclaveComponent,
    data: {
      keywords: 'Classic Conclave ||G H Raisoni Sports & Cultural Foundation',
      description: 'Classic Conclave ||G H Raisoni Sports & Cultural Foundation',
      title: 'Classic Conclave ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mangeshkar', component: LataMangeshkarComponent,
    data: {
      keywords: 'Lata Mangeshkar ||G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mangeshkar ||G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mangeshkar ||G H Raisoni Sports & Cultural Foundation'
    }
  },

  {
    path: 'fide-chesscompetition', component: FideChesscompetitionComponent,
    data: {
      keywords: 'Fide Chess Competition ||G H Raisoni Sports & Cultural Foundation',
      description: 'Fide Chess Competition ||G H Raisoni Sports & Cultural Foundation',
      title: 'Fide Chess Competition ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'arvind-upadhye', component: ArvindUpadhyeComponent,
    data: {
      keywords: 'Arvind Upadhye ||G H Raisoni Sports & Cultural Foundation',
      description: 'Arvind Upadhye ||G H Raisoni Sports & Cultural Foundation',
      title: 'Arvind Upadhye ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'kalyani-deshpande', component: KalyaniDeshpandeComponent,
    data: {
      keywords: 'Kalyani Deshpande ||G H Raisoni Sports & Cultural Foundation',
      description: 'Kalyani Deshpande ||G H Raisoni Sports & Cultural Foundation',
      title: 'Kalyani Deshpande ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'hrishikesh-karmarkar', component: HrishikeshKarmarkarComponent,
    data: {
      keywords: 'Hrishikesh Karmarkar ||G H Raisoni Sports & Cultural Foundation',
      description: 'Hrishikesh Karmarkar ||G H Raisoni Sports & Cultural Foundation',
      title: 'Hrishikesh Karmarkar ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'online-rahul-joshi', component: OnlineRahulJoshiComponent,
    data: {
      keywords: 'Online Rahul Joshi ||G H Raisoni Sports & Cultural Foundation',
      description: 'Online Rahul Joshi ||G H Raisoni Sports & Cultural Foundation',
      title: 'Online Rahul Joshi ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'online-sadhana-shiledar', component: OnlineSadhanaShiledarComponent,
    data: {
      keywords: 'Online Sadhana Shiledar||G H Raisoni Sports & Cultural Foundation',
      description: 'Online Sadhana Shiledar||G H Raisoni Sports & Cultural Foundation',
      title: 'Online Sadhana Shiledar||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'online-bhupaal-panshikar', component: OnlineBhupaalPanshikarComponent,
    data: {
      keywords: 'Online Bhupaal Panshikar||G H Raisoni Sports & Cultural Foundation',
      description: 'Online Bhupaal Panshikar||G H Raisoni Sports & Cultural Foundation',
      title: 'Online Bhupaal Panshikar||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'vivek-bansod', component: VivekBansodComponent,
    data: {
      keywords: 'Vivek Bansod||G H Raisoni Sports & Cultural Foundation',
      description: 'Vivek Bansod||G H Raisoni Sports & Cultural Foundation',
      title: 'Vivek Bansod||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'swar-rang', component: SwarRangComponent,
    data: {
      keywords: 'Swar Rang||G H Raisoni Sports & Cultural Foundation',
      description: 'Swar Rang||G H Raisoni Sports & Cultural Foundation',
      title: 'Swar Rang||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sjan-award', component: SjanAwardComponent,
    data: {
      keywords: 'Sjan Award||G H Raisoni Sports & Cultural Foundation',
      description: 'Sjan Award||G H Raisoni Sports & Cultural Foundation',
      title: 'Sjan Award||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'konkan-kanya', component: KonkanKanyaComponent,
    data: {
      keywords: 'Konkan Kanya||G H Raisoni Sports & Cultural Foundation',
      description: 'Konkan Kanya||G H Raisoni Sports & Cultural Foundation',
      title: 'Konkan Kanya||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ganesha-utsava', component: GaneshaUtsavaComponent,
    data: {
      keywords: 'Ganesha Utsava ||G H Raisoni Sports & Cultural Foundation',
      description: 'Ganesha Utsava ||G H Raisoni Sports & Cultural Foundation',
      title: 'Ganesha Utsava ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'shivaji-mahotsav', component: ShivajiMahotsavComponent,
    data: {
      keywords: 'Shivaji Mahotsav ||G H Raisoni Sports & Cultural Foundation',
      description: 'Shivaji Mahotsav ||G H Raisoni Sports & Cultural Foundation',
      title: 'Shivaji Mahotsav ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dance-city-dance', component: DanceCityDanceComponent,
    data: {
      keywords: 'Shivaji Mahotsav ||G H Raisoni Sports & Cultural Foundation',
      description: 'Shivaji Mahotsav ||G H Raisoni Sports & Cultural Foundation',
      title: 'Shivaji Mahotsav ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'flash-mob', component: FlashMobComponent,
    data: {
      keywords: 'Flash Mob ||G H Raisoni Sports & Cultural Foundation',
      description: 'Flash Mob ||G H Raisoni Sports & Cultural Foundation',
      title: 'Flash Mob ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya', component: DhamaalDandiyaComponent,
    data: {
      keywords: 'Dhamaal Dandiya ||G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya ||G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-chess2021', component: FideChess2021Component,
    data: {
      keywords: 'Fide Chess 2021 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Fide Chess 2021 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Fide Chess 2021 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-chess2019', component: FideChess2019Component,
    data: {
      keywords: 'Fide Chess 2019 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Fide Chess 2019 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Fide Chess 2019 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-chess2018', component: FideChess2018Component,
    data: {
      keywords: 'Fide Chess 2018 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Fide Chess 2018 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Fide Chess 2018 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'devaki-pandit', component: DevakiPanditComponent,
    data: {
      keywords: 'Devaki Pandit ||G H Raisoni Sports & Cultural Foundation',
      description: 'Devaki Pandit ||G H Raisoni Sports & Cultural Foundation',
      title: 'Devaki Pandit ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'aditi-upadhya', component: AditiUpadhyaComponent,
    data: {
      keywords: 'Aditi Upadhya ||G H Raisoni Sports & Cultural Foundation',
      description: 'Aditi Upadhya ||G H Raisoni Sports & Cultural Foundation',
      title: 'Aditi Upadhya ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'prasad-khaparde', component: PrasadKhapardeComponent,
    data: {
      keywords: 'Prasad Khaparde ||G H Raisoni Sports & Cultural Foundation',
      description: 'Prasad Khaparde ||G H Raisoni Sports & Cultural Foundation',
      title: 'Prasad Khaparde ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'manjusha-patil', component: ManjushaPatilComponent,
    data: {
      keywords: 'Fide Chess 2018 ||G H Raisoni Sports & Cultural Foundation',
      description: 'Fide Chess 2018 ||G H Raisoni Sports & Cultural Foundation',
      title: 'Fide Chess 2018 ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'vidushi', component: VidushiComponent,
    data: {
      keywords: 'Vidushi ||G H Raisoni Sports & Cultural Foundation',
      description: 'Vidushi ||G H Raisoni Sports & Cultural Foundation',
      title: 'Vidushi ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'urvashi-shah', component: UrvashiShahComponent,
    data: {
      keywords: 'Urvashi Shah ||G H Raisoni Sports & Cultural Foundation',
      description: 'Urvashi Shah ||G H Raisoni Sports & Cultural Foundation',
      title: 'Urvashi Shah ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'bhupaal-panshikar', component: BhupaalPanshikarComponent,
    data: {
      keywords: 'Bhupaal Panshikar ||G H Raisoni Sports & Cultural Foundation',
      description: 'Bhupaal Panshikar ||G H Raisoni Sports & Cultural Foundation',
      title: 'Bhupaal Panshikar ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'kakoli', component: KakoliComponent,
    data: {
      keywords: 'kakoli ||G H Raisoni Sports & Cultural Foundation',
      description: 'kakoli ||G H Raisoni Sports & Cultural Foundation',
      title: 'kakoli ||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'priyanka', component: PriyankaComponent,
    data: {
      keywords: 'Priyanka||G H Raisoni Sports & Cultural Foundation',
      description: 'Priyanka||G H Raisoni Sports & Cultural Foundation',
      title: 'Priyanka||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'manbhavan', component: ManbhavanComponent,
    data: {
      keywords: 'Manbhavan||G H Raisoni Sports & Cultural Foundation',
      description: 'Manbhavan||G H Raisoni Sports & Cultural Foundation',
      title: 'Manbhavan||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nirali-kartik', component: NiraliKartikComponent,
    data: {
      keywords: 'Nirali Kartik||G H Raisoni Sports & Cultural Foundation',
      description: 'Nirali Kartik||G H Raisoni Sports & Cultural Foundation',
      title: 'Nirali Kartik||G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'jugalbandi', component: JugalbandiComponent,
    data: {
      keywords: 'Jugalbandi || G H Raisoni Sports & Cultural Foundation',
      description: 'Jugalbandi || G H Raisoni Sports & Cultural Foundation',
      title: 'Jugalbandi || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-summer-camp', component: RegisterSummerCampComponent,
    data: {
      keywords: 'Register Summer Camp || G H Raisoni Sports & Cultural Foundation',
      description: 'Register Summer Camp || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Summer Camp || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'association', component: AssociationComponent,
    data: {
      keywords: 'Association || G H Raisoni Sports & Cultural Foundation',
      description: 'Association || G H Raisoni Sports & Cultural Foundation',
      title: 'Association || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'rumi-hai', component: RumiHaiComponent,
    data: {
      keywords: 'Rumi Hai || G H Raisoni Sports & Cultural Foundation',
      description: 'Rumi Hai || G H Raisoni Sports & Cultural Foundation',
      title: 'Rumi Hai || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sawani-sathaye', component: SawaniSathayeComponent,
    data: {
      keywords: 'Sawani Sathaye || G H Raisoni Sports & Cultural Foundation',
      description: 'Sawani Sathaye || G H Raisoni Sports & Cultural Foundation',
      title: 'Sawani Sathaye || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'konkan-kanya-registartion', component: KonkanKanyaRegistartionComponent,
    data: {
      keywords: 'Konkan Kanya Registartion || G H Raisoni Sports & Cultural Foundation',
      description: 'Konkan Kanya Registartion || G H Raisoni Sports & Cultural Foundation',
      title: 'Konkan Kanya Registartion || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'melvin-louise', component: MelvinLouiseComponent,
    data: {
      keywords: 'Melvin Louise || G H Raisoni Sports & Cultural Foundation',
      description: 'Melvin Louise || G H Raisoni Sports & Cultural Foundation',
      title: 'Melvin Louise || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-lata-mangeshkar', component: RegisterMelvinLouiseComponent,
    data: {
      keywords: 'Lata Mangeshkar|| G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mangeshkar|| G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mangeshkar|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'slum-soccer', component: SlumSoccerComponent,
    data: {
      keywords: 'Lata Mangeshkar|| G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mangeshkar|| G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mangeshkar|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'support-encouragement', component: SupportEncouragementComponent,
    data: {
      keywords: 'Support Encouragement|| G H Raisoni Sports & Cultural Foundation',
      description: 'Support Encouragement|| G H Raisoni Sports & Cultural Foundation',
      title: 'Support Encouragement|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'payment-form', component: PaymentFormComponent,
    data: {
      keywords: 'Melvin Louise || G H Raisoni Sports & Cultural Foundation',
      description: 'Melvin Louise || G H Raisoni Sports & Cultural Foundation',
      title: 'Melvin Louise || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'musical-comp', component: MusicalCompComponent,
    data: {
      keywords: 'Musical || G H Raisoni Sports & Cultural Foundation',
      description: 'Musical || G H Raisoni Sports & Cultural Foundation',
      title: 'Musical || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'shootsight-comp', component: ShootsightCompComponent,
    data: {
      keywords: 'Shootsight || G H Raisoni Sports & Cultural Foundation',
      description: 'Shootsight || G H Raisoni Sports & Cultural Foundation',
      title: 'Shootsight || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'stepup', component: StepupComponent,
    data: {
      keywords: 'Stepup || G H Raisoni Sports & Cultural Foundation',
      description: 'Stepup || G H Raisoni Sports & Cultural Foundation',
      title: 'Stepup || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'naad-ninaad', component: NaadNinaadComponent,
    data: {
      keywords: 'Naad Ninaad || G H Raisoni Sports & Cultural Foundation',
      description: 'Naad Ninaad || G H Raisoni Sports & Cultural Foundation',
      title: 'Naad Ninaad || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'thank-you', component: ThankYouComponent,
    data: {
      keywords: 'Thank You || G H Raisoni Sports & Cultural Foundation',
      description: 'Thank You || G H Raisoni Sports & Cultural Foundation',
      title: 'Thank You || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'itoohavetalent-2022', component: Itoohavetalent22Component,
    data: {
      keywords: 'I too have talent || G H Raisoni Sports & Cultural Foundation',
      description: 'I too have talent || G H Raisoni Sports & Cultural Foundation',
      title: 'I too have talent || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dress-design', component: DressDesignComponent,
    data: {
      keywords: 'I too have talent || G H Raisoni Sports & Cultural Foundation',
      description: 'I too have talent || G H Raisoni Sports & Cultural Foundation',
      title: 'I too have talent || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'employee-sport-twenty-three', component: EmployeeSportTwentyThreeComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'harshita-gautam', component: HarshitaGautamComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pg-redirect', component: PgRedirectComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pg-response', component: PgResponseComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'viewharshita-gautam', component: ViewharshitaGautamComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-tournament23', component: ChessTournament23Component,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-lata-mangeshkar-wardha', component: RegisterLataMangeshkarWardhaComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-tournament-bhandara', component: ChessTournamentBhandaraComponent,
    data: {
      keywords: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      description: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation',
      title: 'Employee Sport and Cultural Meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nrutyavishkar', component: NrutyavishkarComponent,
    data: {
      keywords: 'Nrutyavishkar || G H Raisoni Sports & Cultural Foundation',
      description: 'Nrutyavishkar || G H Raisoni Sports & Cultural Foundation',
      title: 'Nrutyavishkar || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mageshkar-wardha-event', component: LataMageshkarWardhaEventComponent,
    data: {
      keywords: 'Lata Mageshkar Wardha Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mageshkar Wardha Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mageshkar Wardha Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mageshkar-chandrapur-event', component: LataMageshkarChandrapurEventComponent,
    data: {
      keywords: 'Lata Mageshkar Chandrapur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mageshkar Chandrapur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mageshkar Chandrapur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mageshkar-bhandara-event', component: LataMageshkarBhandaraEventComponent,
    data: {
      keywords: 'Lata Mageshkar Bhandara Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mageshkar Bhandara Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mageshkar Bhandara Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'musical-rejuvenation', component: MusicalRejuvenationComponent,
    data: {
      keywords: 'Musical Rejuvenation Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Musical Rejuvenation Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Musical Rejuvenation Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sanjeev-abhyankar-amravati', component: SanjeevAbhyankarAmravatiComponent,
    data: {
      keywords: 'Sanjeev Abhyankar Amravati Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Sanjeev Abhyankar Amravati Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Sanjeev Abhyankar Amravati Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sanjeev-abhyankar-nagpur', component: SanjeevAbhyankarNagpurComponent,
    data: {
      keywords: 'Sanjeev Abhyankar Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Sanjeev Abhyankar Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Sanjeev Abhyankar Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'unforgettable-kk', component: UnforgettableKkComponent,
    data: {
      keywords: 'Unforgettable Kk Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Unforgettable Kk Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Unforgettable Kk Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-unforgettable-kk', component: RegisterUnforgettableKkComponent,
    data: {
      keywords: 'Register Unforgettable Kk Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Register Unforgettable Kk Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Unforgettable Kk Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-chess2023', component: FideChess2023Component,
    data: {
      keywords: 'Fide Chess 2023 Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Fide Chess 2023 Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Fide Chess 2023 Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-championship2023', component: ChessChampionship2023Component,
    data: {
      keywords: 'Chess Championship 2023 Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Chess Championship 2023 Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Chess Championship 2023 Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-dance-event', component: RegisterDanceEventComponent,
    data: {
      keywords: 'Register Dance Event Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'Register Dance Event Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Dance Event Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'memorial-cup', component: MemorialCupComponent,
    data: {
      keywords: 'Memorial Cup Component Nagpur Event || G H Raisoni Sports & Cultural Foundation',
      description: 'SAPT Maharshi Bahuuddeshiye Sanstha Nagpur & Unity Football Academy || G H Raisoni Sports & Cultural Foundation',
      title: 'Memorial Cup Component Nagpur Event || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-classical-vocal-amt', component: RegisterClassicalVocalAmtComponent,
    data: {
      keywords: 'Register Indian  Classical Vocal Performance, Amravati || G H Raisoni Sports & Cultural Foundation',
      description: 'SAPT Maharshi Bahuuddeshiye Sanstha Nagpur & Unity Football Academy || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Indian  Classical Vocal Performance, Amravati || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-classical-vocal-nagpur', component: RegisterClassicalVocalNagpurComponent,
    data: {
      keywords: 'Register Indian  Classical Vocal Performance, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'SAPT Maharshi Bahuuddeshiye Sanstha Nagpur & Unity Football Academy || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Indian  Classical Vocal Performance, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'siyavr-ram', component: SiyavrRamComponent,
    data: {
      keywords: 'Register Indian  Classical Vocal Performance, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'SAPT Maharshi Bahuuddeshiye Sanstha Nagpur & Unity Football Academy || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Indian  Classical Vocal Performance, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-memorial-archery-tournament', component: RegisterMemorialArcheryTournamentComponent,
    data: {
      keywords: 'Register Memorial Archery Tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'Register Memorial Archery Tournament || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Memorial Archery Tournament, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mangeshkar-yavatmal-event', component: LataMangeshkarYavatmalEventComponent,
    data: {
      keywords: 'Lata Mangeshkar YavatmalEvent, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mangeshkar Yavatmal Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mangeshkar Yavatmal Event, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mangeshkar-akola-event', component: LataMangeshkarAkolaEventComponent,
    data: {
      keywords: 'Lata Mangeshkar Akol Event, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'Lata Mangeshkar Akola Event || G H Raisoni Sports & Cultural Foundation',
      title: 'Lata Mangeshkar Akola Event, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-lata-mangeshkar-chhindwara', component: RegisterLataMangeshkarChhindwaraComponent,
    data: {
      keywords: 'Register Lata Mangeshkar Chhindwara, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'Register Lata Mangeshkar Chhindwara || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Lata Mangeshkar Chhindwara, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'register-lata-mangeshkar-yavatmal', component: RegisterLataMangeshkarYavatmalComponent,
    data: {
      keywords: 'Register Lata Mangeshkar Yavatmal, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'Register Lata Mangeshkar Yavatmal || G H Raisoni Sports & Cultural Foundation',
      title: 'Register Lata Mangeshkar Yavatmal, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-district-under-elleven-tournament', component: NagpurDistrictUnderEllevenTournamentComponent,
    data: {
      keywords: 'nagpur-district-under-elleven-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'nagpur-district-under-elleven-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'nagpur-district-under-elleven-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'testimonial', component: TestimonialComponent,
    data: {
      keywords: 'testimonial, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'testimonial, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'testimonial, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'basketball-championship', component: BasketballChampionshipComponent,
    data: {
      keywords: 'basketball-championship, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'basketball-championship, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'basketball-championship, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'lata-mangeshkar-betul-event', component: LataMangeshkarBetulEventComponent,
    data: {
      keywords: 'lata-mangeshkar-betul-event, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'lata-mangeshkar-betul-event, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'lata-mangeshkar-betul-event, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'register-lata-mangeshkar-betul', component: RegisterLataMangeshkarBetulComponent,
    data: {
      keywords: 'register-lata-mangeshkar-betul, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'register-lata-mangeshkar-betul, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'register-lata-mangeshkar-betul, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'lata-mangeshkar-chhindwara-event', component: LataMangeshkarChhindwaraEventComponent,
    data: {
      keywords: 'lata-mangeshkar-chhindwara-event, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'lata-mangeshkar-chhindwara-event, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'lata-mangeshkar-chhindwara-event, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'badminton-tournament', component: BadmintonTournamentComponent,
    data: {
      keywords: 'badminton-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'badminton-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'badminton-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-rating-chess2023', component: FideRatingChess2023Component,
    data: {
      keywords: 'fide-rating-chess-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'fide-rating-chess-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'fide-rating-chess-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'fide-rating-chess-tournament', component: FideRatingChessTournamentComponent,
    data: {
      keywords: 'fide-rating-chess-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'fide-rating-chess-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'fide-rating-chess-tournament, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'archery-tournament-pune', component: ArcheryTournamentPuneComponent,
    data: {
      keywords: 'archery-tournament-pune, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'archery-tournament-pune, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'archery-tournament-pune, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'archery-tournament-nagpur', component: ArcheryTournamentNagpurComponent,
    data: {
      keywords: 'archery-tournament-nagpur, Nagpur || G H Raisoni Sports & Cultural Foundation',
      description: 'archery-tournament-nagpur, Nagpur || G H Raisoni Sports & Cultural Foundation',
      title: 'archery-tournament-nagpur, Nagpur || G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'archery-tournament-amravati', component: ArcheryTournamentAmravatiComponent,
    data: {
      keywords: 'archery-tournament-amravati,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      description: 'archery-tournament-amravati,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      title: 'archery-tournament-amravati,Nagpur|| G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'registration-ankalikar', component: RegistrationAnkalikarComponent,
    data: {
      keywords: 'registration-ankalikar,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      description: 'registration-ankalikar,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      title: 'registration-ankalikar,Nagpur|| G H Raisoni Sports & Cultural Foundation'
    }
  }
  ,
  {
    path: 'vidushi-aarti-ankalikar', component: VidushiAartiAnkalikarComponent,
    data: {
      keywords: 'vidushi-aarti-ankalikar,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      description: 'vidushi-aarti-ankalikar,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      title: 'vidushi-aarti-ankalikar,Nagpur|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'futsal-tournament', component: FutsalTournamentComponent,
    data: {
      keywords: 'futsal-tournament,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      description: 'futsal-tournament,Nagpur|| G H Raisoni Sports & Cultural Foundation',
      title: 'futsal-tournament,Nagpur|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'table-tennis-amravati', component: TableTennisAmravatiComponent,
    data: {
      keywords: 'Table Tennis Tournament|| G H Raisoni Sports & Cultural Foundation',
      description: 'Table Tennis Tournament|| G H Raisoni Sports & Cultural Foundation',
      title: 'Table Tennis Tournament|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'national-federation-of-blind', component: NationalFederationOfBlindComponent,
    data: {
      keywords: 'National Federation of Blind|| G H Raisoni Sports & Cultural Foundation',
      description: 'National Federation of Blind|| G H Raisoni Sports & Cultural Foundation',
      title: 'National Federation of Blind|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhamaal-dandiya-year2023', component: DhamaalDandiyaYear2023Component,
    data: {
      keywords: 'Dhamaal Dandiya Year 2023|| G H Raisoni Sports & Cultural Foundation',
      description: 'Dhamaal Dandiya Year 2023|| G H Raisoni Sports & Cultural Foundation',
      title: 'Dhamaal Dandiya Year 2023|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pune-international-chess-tournament', component: PuneInternationalChessTournamentComponent,
    data: {
      keywords: 'pune-international-chess-tournament|| G H Raisoni Sports & Cultural Foundation',
      description: 'pune-international-chess-tournament|| G H Raisoni Sports & Cultural Foundation',
      title: 'pune-international-chess-tournament|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'neev-employee-sports-meet', component: NeevEmployeeSportsMeetComponent,
    data: {
      keywords: 'neev-employee-sports-meet || G H Raisoni Sports & Cultural Foundation',
      description: 'neev-employee-sports-meet || G H Raisoni Sports & Cultural Foundation',
      title: 'neev-employee-sports-meet || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sjan-award-2024', component: SjanAwardTwentyfourComponent,
    data: {
      keywords: 'sjan-award-2024 || G H Raisoni Sports & Cultural Foundation',
      description: 'sjan-award-2024 || G H Raisoni Sports & Cultural Foundation',
      title: 'sjan-award-2024 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'football-tournament-2024', component: FootballTournamentComponent,
    data: {
      keywords: 'football-tournament-2024 || G H Raisoni Sports & Cultural Foundation',
      description: 'football-tournament-2024 || G H Raisoni Sports & Cultural Foundation',
      title: 'football-tournament-2024 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'swimming-competition', component: SwimmingCompetitionComponent,
    data: {
      keywords: 'swimmingcompetition || G H Raisoni Sports & Cultural Foundation',
      description: 'swimmingcompetition || G H Raisoni Sports & Cultural Foundation',
      title: 'swimmingcompetition || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-championship', component: ChessChampionshipComponent,
    data: {
      keywords: 'chess-championship || G H Raisoni Sports & Cultural Foundation',
      description: 'chess-championship || G H Raisoni Sports & Cultural Foundation',
      title: 'chess-championship || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'armsport-competition', component: ArmsportCompetitionComponent,
    data: {
      keywords: 'armsport-competition || G H Raisoni Sports & Cultural Foundation',
      description: 'armsport-competition || G H Raisoni Sports & Cultural Foundation',
      title: 'armsport-competition || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-chess-amt', component: FideChessAmtComponent,
    data: {
      keywords: '1 st  G.H. Raisoni Memorial Amavati International FIDE Rapid Rating Chess Tournament gets inaugurated by Dr.Anil Bonde, MP, Rajyasabha. || G H Raisoni Sports & Cultural Foundation',
      description: '1 st  G.H. Raisoni Memorial Amavati International FIDE Rapid Rating Chess Tournament gets inaugurated by Dr.Anil Bonde, MP, Rajyasabha. || G H Raisoni Sports & Cultural Foundation',
      title: '1 st  G.H. Raisoni Memorial Amavati International FIDE Rapid Rating Chess Tournament gets inaugurated by Dr.Anil Bonde, MP, Rajyasabha. || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sadabai-raisoni-womens-batminton', component: SadabaiRaisoniWomensBatmintonComponent,
    data: {
      keywords: 'Sadabai Raisoni Memorial Maharashtra State level Womens Badminton Tournament 2024 || G H Raisoni Sports & Cultural Foundation',
      description: 'Sadabai Raisoni Memorial Maharashtra State level Womens Badminton Tournament 2024 || G H Raisoni Sports & Cultural Foundation',
      title: 'Sadabai Raisoni Memorial Maharashtra State level Womens Badminton Tournament 2024 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'mendatory-disclosure', component: MendatoryDisclosureComponent,
    data: {
      keywords: 'Sadabai Raisoni Memorial Maharashtra State level Womens Badminton Tournament 2024 || G H Raisoni Sports & Cultural Foundation',
      description: 'Sadabai Raisoni Memorial Maharashtra State level Womens Badminton Tournament 2024 || G H Raisoni Sports & Cultural Foundation',
      title: 'Sadabai Raisoni Memorial Maharashtra State level Womens Badminton Tournament 2024 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'second-chess-championship', component: SecondChessChampionshipComponent,
    data: {
      keywords: 'second-chess-championship 2024 || G H Raisoni Sports & Cultural Foundation',
      description: 'second-chess-championship 2024 || G H Raisoni Sports & Cultural Foundation',
      title: 'second-chess-championship 2024 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-open-girls-chess', component: NagpurOpenGirlsChessComponent,
    data: {
      keywords: 'second-chess-championship 2024 || G H Raisoni Sports & Cultural Foundation',
      description: 'second-chess-championship 2024 || G H Raisoni Sports & Cultural Foundation',
      title: 'second-chess-championship 2024 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'memorial-international', component: MemorialInternationalComponent,
    data: {
      keywords: '17th G H Raisoni Memorial international Rating Chess Festival  || G H Raisoni Sports & Cultural Foundation',
      description: '17th G H Raisoni Memorial international Rating Chess Festival  || G H Raisoni Sports & Cultural Foundation',
      title: '17th G H Raisoni Memorial international Rating Chess Festival  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'second-fade-rating-chess-tournament', component: SecondFadeRatingChessTournamentComponent,
    data: {
      keywords: '2nd G.H. Raisoni Memorial Pune International FIDE Rating Open Chess Tournament  || G H Raisoni Sports & Cultural Foundation',
      description: '2nd G.H. Raisoni Memorial Pune International FIDE Rating Open Chess Tournament  || G H Raisoni Sports & Cultural Foundation',
      title: '2nd G.H. Raisoni Memorial Pune International FIDE Rating Open Chess Tournament  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'badminton-compe-pune', component: BadmintonCompePuneComponent,
    data: {
      keywords: 'Badminton Competition Pune 2024   || G H Raisoni Sports & Cultural Foundation',
      description: 'Badminton Competition Pune 2024   || G H Raisoni Sports & Cultural Foundation',
      title: 'Badminton Competition Pune 2024   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'badminton-competition', component: BadmintonCompetitionComponent,
    data: {
      keywords: 'Badminton Competition 2024  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Badminton Competition 2024   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Badminton Competition 2024  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sjan-raisoni-achievers-award', component: SjanRaisoniAchieversAwardComponent,
    data: {
      keywords: ' Sjan Raisoni Achievers Award 2024  ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Sjan Raisoni Achievers Award 2024   ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Sjan Raisoni Achievers Award 2024  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'blitz-chess-championship', component: BlitzChessChampionshipComponent,
    data: {
      keywords: ' Sjan Raisoni Achievers Award 2024  ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Sjan Raisoni Achievers Award 2024   ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Sjan Raisoni Achievers Award 2024  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'badminton-compe-vidarbh', component: BadmintonCompeVidarbhComponent,
    data: {
      keywords: ' Yonex-Sunrise G H Raisoni Memorial Vidarbha Level Badminton Tournament   ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Yonex-Sunrise G H Raisoni Memorial Vidarbha Level Badminton Tournament    ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Yonex-Sunrise G H Raisoni Memorial Vidarbha Level Badminton Tournament   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'karandak-auditions', component: KarandakAuditionsComponent,
    data: {
      keywords: 'Karandak Auditions   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Karandak Auditions    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Karandak Auditions   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'karandak-auditions-kolhapur', component: KarandakAuditionsKolhapurComponent,
    data: {
      keywords: 'Karandak Auditions Kolhapur   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Karandak Auditions Kolhapur    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Karandak Auditions Kolhapur   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'karandak-auditions-ratnagiri', component: KarandakAuditionsRatnagiriComponent,
    data: {
      keywords: 'Karandak Auditions Ratnagiri   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Karandak Auditions Ratnagiri    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Karandak Auditions Ratnagiri   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'karandak-auditions-pune', component: KarandakAuditionsPuneComponent,
    data: {
      keywords: 'Karandak Auditions Pune   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Karandak Auditions Pune    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Karandak Auditions Pune   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pune-checkmate-challenge', component: PuneCheckmateChallengeComponent,
    data: {
      keywords: 'Pune Checkmate Challenge   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Pune Checkmate Challenge    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Pune Checkmate Challenge   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'jhipru-and-chimnayano', component: JhipruAndChimnayanoComponent,
    data: {
      keywords: 'Jhipru and Chimnayano   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Jhipru and Chimnayano    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Jhipru and Chimnayano   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'yonex-sunrise-chandrapur', component: YonexSunriseChandrapurComponent,
    data: {
      keywords: 'Yonex Sunrise Chandrapur   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Yonex Sunrise Chandrapur    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Yonex Sunrise Chandrapur   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'yonex-sunrise-vidarbha-leval', component: YonexSunriseVidarbhaLevalComponent,
    data: {
      keywords: 'Yonex Sunrise Vidarbha Leval   ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Yonex Sunrise Vidarbha Leval    ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Yonex Sunrise Vidarbha Leval   || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'cricket-tournament-2025', component: CricketTournamentComponent,
    data: {
      keywords: 'Cricket Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Cricket Tournament   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Cricket Tournament  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sjan-t20-cricket-tournament', component: SjanT20CricketTournamentComponent,
    data: {
      keywords: 'Cricket Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Cricket Tournament   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Cricket Tournament  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'womens-chess', component: WomensChessComponent,
    data: {
      keywords: 'Womens Chess  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Womens Chess   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Womens Chess  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'open-and-girls-selection-chess', component: OpenAndGirlsSelectionChessComponent,
    data: {
      keywords: 'Open And Girls Selection Chess  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Open And Girls Selection Chess   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Open And Girls Selection Chess  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'badminton-championship', component: BadmintonChampionshipComponent,
    data: {
      keywords: 'Open And Girls Selection Chess  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Open And Girls Selection Chess   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Open And Girls Selection Chess  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'buldhana-district-badminton-championship', component: BuldhanaDistrictBadmintonChampionshipComponent,
    data: {
      keywords: 'Buldhana District Badminton Championship ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Buldhana District Badminton Championship  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Buldhana District Badminton Championship || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'fide-rapid-rating-chess-tournament', component: FideRapidRatingChessTournamentComponent,
    data: {
      keywords: 'Buldhana District Badminton Championship ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Buldhana District Badminton Championship  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Buldhana District Badminton Championship || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'mh-womens-badminton-tournament', component: MhWomensBadmintonTournamentComponent,
    data: {
      keywords: 'Yonex-Sunrise Sadabai Raisoni Memorial Maharashtra State Women’s Badminton Tournament 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Yonex-Sunrise Sadabai Raisoni Memorial Maharashtra State Women’s Badminton Tournament 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Yonex-Sunrise Sadabai Raisoni Memorial Maharashtra State Women’s Badminton Tournament 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'international-fide-rapid-rating-chess-tournament', component: InternationalFideRapidRatingChessTournamentComponent,
    data: {
      keywords: 'International Fide Rapid Rating Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: 'International Fide Rapid Rating Chess Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'International Fide Rapid Rating Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'bhandara-one-day-rapid-chess-tournament', component: BhandaraOneDayRapidChessTournamentComponent,
    data: {
      keywords: 'Bhandara One Day Rapid Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Bhandara One Day Rapid Chess Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Bhandara One Day Rapid Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'memorial-chess-tournament-gondia', component: MemorialChessTournamentGondiaComponent,
    data: {
      keywords: 'Memorial Chess Tournament Gondia ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Memorial Chess Tournament Gondia  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Memorial Chess Tournament Gondia || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'extended-support', component: ExtendedSupportComponent,
    data: {
      keywords: 'Extended Support ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Extended Support  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Extended Support || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-championship-under-seven-seventeen', component: ChessChampionshipUnderSevenSeventeenComponent,
    data: {
      keywords: 'Extended Support ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Extended Support  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Extended Support || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-championship-under-nine-nineteen', component: ChessChampionshipUnderNineNineteenComponent,
    data: {
      keywords: 'Extended Support ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Extended Support  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Extended Support || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-championship-under-eleven-fifteen', component: ChessChampionshipUnderElevenFifteenComponent,
    data: {
      keywords: 'Extended Support ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Extended Support  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Extended Support || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-district-amateur-badminton-tournament', component: NagpurDistrictAmateurBadmintonTournamentComponent,
    data: {
      keywords: 'Nagpur District Amateur Badminton Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nagpur District Amateur Badminton Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nagpur District Amateur Badminton Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'buldhana-district-badminton-championship-twenty-five', component: BuldhanaDistrictBadmintonChampionshipTwentyFiveComponent,
    data: {
      keywords: 'Buldhana District Badminton Championship 2025 ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Buldhana District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Buldhana District Badminton Championship 2025 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-tournament-twenty-five', component: ChessTournamentTwentyFiveComponent,
    data: {
      keywords: 'Chess Tournament 2025 ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Chess Tournament 2025  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Chess Tournament 2025 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'raisoni-memorial-vidarbha-level-badminton-tournament', component: RaisoniMemorialVidarbhaLevelBadmintonTournamentComponent,
    data: {
      keywords: 'G H Raisoni Memorial Vidarbha Level Badminton Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Vidarbha Level Badminton Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Vidarbha Level Badminton Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'palghar-badminton-tournament', component: PalgharBadmintonTournamentComponent,
    data: {
      keywords: 'G H Raisoni Memorial Palghar District Badminton Championship 2025||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Palghar District Badminton Championship 2025 ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Palghar District Badminton Championship 2025|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'gadchiroli-district-badminton-championship', component: GadchiroliDistrictBadmintonChampionshipComponent,
    data: {
      keywords: 'G H Raisoni Memorial Gadchiroli District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Gadchiroli District Badminton Championship 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Gadchiroli District Badminton Championship 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'memorial-chess-tournament-ratnagiri', component: MemorialChessTournamentRatnagiriComponent,
    data: {
      keywords: 'G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-district-first-selection-badminton-tournament', component: NagpurDistrictFirstSelectionBadmintonTournamentComponent,
    data: {
      keywords: 'Nagpur District 1st Selection Badminton Tournament 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nagpur District 1st Selection Badminton Tournament 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nagpur District 1st Selection Badminton Tournament 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nanded-district-chess-selection-tournament', component: NandedDistrictChessSelectionTournamentComponent,
    data: {
      keywords: 'Nagpur District Chess Selection Badminton 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nagpur District Chess Selection Badminton 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nagpur District Chess Selection Badminton 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'dhule-dist-badminton-championship', component: DhuleDistBadmintonChampionshipComponent,
    data: {
      keywords: 'G H Raisoni Memorial Dhule District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Dhule District Badminton Championship 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Dhule District Badminton Championship 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pune-dist-badminton-championship', component: PuneDistBadmintonChampionshipComponent,
    data: {
      keywords: 'G H Raisoni Memorial Pune District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Pune District Badminton Championship 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Pune District Badminton Championship 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'neev-twenty-five', component: NeevTwentyFiveComponent,
    data: {
      keywords: 'G H Raisoni Memorial Pune District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Pune District Badminton Championship 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Pune District Badminton Championship 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'telangana-state-senior-bad-cham', component: TelanganaStateSeniorBadChamComponent,
    data: {
      keywords: 'G H Raisoni Memorial Pune District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Pune District Badminton Championship 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Pune District Badminton Championship 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-competition-prize-distrubution', component: ChessCompetitionPrizeDistrubutionComponent,
    data: {
      keywords: 'Chess Competition Prize Distrubution 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Chess Competition Prize Distrubution 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Chess Competition Prize Distrubution 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'wrestling-championships-twenty-five', component: WrestlingChampionshipsTwentyFiveComponent,
    data: {
      keywords: 'Wrestling Championships 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Wrestling Championships 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Wrestling Championships 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'swaragini', component: SwaraginiComponent,
    data: {
      keywords: 'एक शाम गीतों के नाम 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'एक शाम गीतों के नाम 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'एक शाम गीतों के नाम 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ghr-memorial-pune-fide-rapid-rating-chess-twentyfive', component: GhrMemorialPuneFideRapidRatingChessTwentyfiveComponent,
    data: {
      keywords: 'G H Raisoni Memorial Pune Fide Rapid Rating Chess 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Pune Fide Rapid Rating Chess 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Pune Fide Rapid Rating Chess 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ghraisoni-memorial-amravati-district-badminton-championship-twentyfive', component: GhraisoniMemorialAmravatiDistrictBadmintonChampionshipTwentyfiveComponent,
    data: {
      keywords: 'G H Raisoni Memorial Amravati District Badminton Championship 2025  ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Amravati District Badminton Championship 2025   ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Amravati District Badminton Championship 2025  || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'amravati-district-badminton', component: AmravatiDistrictBadmintonComponent,
    data: {
      keywords: 'G. H. Raisoni Memorial Amravati District Badminton Championship 2026 || G H Raisoni Sports & Cultural Foundation',
      description: 'G. H. Raisoni Memorial Amravati District Badminton Championship 2026 || G H Raisoni Sports & Cultural Foundation',
      title: 'G. H. Raisoni Memorial Amravati District Badminton Championship 2026 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-association-ngp-celebrates-international-chess-day', component: ChessAssociationNgpCelebratesInternationalChessDayComponent,
    data: {
      keywords: 'Chess Association Nagpur Celebrates 101st International Chess Day ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Chess Association Nagpur Celebrates 101st International Chess Day  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Chess Association Nagpur Celebrates 101st International Chess Day || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ek-sham-geeto-ke-naam', component: EkShamGeetoKeNaamComponent,
    data: {
      keywords: 'एक शाम गीतों के नाम ||  G H Raisoni Sports & Cultural Foundation',
      description: 'एक शाम गीतों के नाम  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'एक शाम गीतों के नाम || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-below-seventeen-hundred-fide-rating-chess-tournament', component: NagpurBelowSeventeenHundredFideRatingChessTournamentComponent,
    data: {
      keywords: 'Nagpur Below 1700 FIDE Rating Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nagpur Below 1700 FIDE Rating Chess Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nagpur Below 1700 FIDE Rating Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nanded-district-badminton-championship', component: NandedDistrictBadmintonChampionshipComponent,
    data: {
      keywords: 'Nanded District Badminton Championship||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nanded District Badminton Championship ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nanded District Badminton Championship|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'gh-raisoni-badminton-under-fifteen-under-seventeen', component: GhRaisoniBadmintonUnderFifteenUnderSeventeenComponent,
    data: {
      keywords: 'Nanded District Badminton Championship||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nanded District Badminton Championship ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nanded District Badminton Championship|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pithora-one-day-rapid-chess-tournament', component: PithoraOneDayRapidChessTournamentComponent,
    data: {
      keywords: 'Pithora One-Day Rapid Chess Tournament 2025 ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Pithora One-Day Rapid Chess Tournament 2025  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Pithora One-Day Rapid Chess Tournament 2025 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sarguja-division-one-day-rapid-chess-tournament', component: SargujaDivisionOneDayRapidChessTournamentComponent,
    data: {
      keywords: 'G H Raisoni Memorial Sarguja Division one day chess Tournament 2025 ||  G H Raisoni Sports & Cultural Foundation',
      description: 'G H Raisoni Memorial Sarguja Division one day chess Tournament 2025  ||  G H Raisoni Sports & Cultural Foundation',
      title: 'G H Raisoni Memorial Sarguja Division one day chess Tournament 2025 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'thane-fide-rapid-chess-tournament', component: ThaneFideRapidChessTournamentComponent,
    data: {
      keywords: '1st G H Raisoni Memorial Thane FIDE Rating Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: '1st G H Raisoni Memorial Thane FIDE Rating Chess Tournament  ||  G H Raisoni Sports & Cultural Foundation',
      title: '1st G H Raisoni Memorial Thane FIDE Rating Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'division-level-chess-meet', component: DivisionLevelChessMeetComponent,
    data: {
      keywords: 'Division Level Chess Meet||  G H Raisoni Sports & Cultural Foundation',
      description: 'Division Level Chess Meet ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Division Level Chess Meet|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'rapid-chess-tournament-concludes', component: RapidChessTournamentConcludesComponent,
    data: {
      keywords: 'Rapid Chess Tournament Concludes||  G H Raisoni Sports & Cultural Foundation',
      description: 'Rapid Chess Tournament Concludes ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Rapid Chess Tournament Concludes|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'marathwada-open-badminton-tournament', component: MarathwadaOpenBadmintonTournamentComponent,
    data: {
      keywords: 'Marathwada Open Badminton Tournament||  G H Raisoni Sports & Cultural Foundation',
      description: 'Marathwada Open Badminton Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Marathwada Open Badminton Tournament|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'raigad-district-level-one-day', component: RaigadDistrictLevelOneDayComponent,
    data: {
      keywords: 'Raigad District Level One Day||  G H Raisoni Sports & Cultural Foundation',
      description: 'Raigad District Level One Day ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Raigad District Level One Day|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'jalna-rapid-chess-tournament', component: JalnaRapidChessTournamentComponent,
    data: {
      keywords: 'Jalna Rapid Chess Tournament||  G H Raisoni Sports & Cultural Foundation',
      description: 'Jalna Rapid Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Jalna Rapid Chess Tournament|| G H Raisoni Sports & Cultural Foundation'
    }
  },

  {
    path: 'nagpur-chess-festival', component: NagpurChessFestivalComponent,
    data: {
      keywords: 'Nagpur Chess Festival||  G H Raisoni Sports & Cultural Foundation',
      description: 'Nagpur Chess Festival ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Nagpur Chess Festival|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'neev-twenty-six', component: NeevTwentySixComponent,
    data: {
      keywords: '22th Neev 2026 ||  G H Raisoni Sports & Cultural Foundation',
      description: '22th Neev 2026 ||  G H Raisoni Sports & Cultural Foundation',
      title: '22th Neev 2026 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'about-foundation', component: AboutFoundationComponent,
    data: {
      keywords: 'About Foundation ||  G H Raisoni Sports & Cultural Foundation',
      description: 'About Foundation ||  G H Raisoni Sports & Cultural Foundation',
      title: 'About Foundation || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'advisory-board', component: AdvisoryBoardComponent,
    data: {
      keywords: 'Advisory Board ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Advisory Board ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Advisory Board || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'about-team', component: AboutTeamComponent,
    data: {
      keywords: 'About Team ||  G H Raisoni Sports & Cultural Foundation',
      description: 'About Team ||  G H Raisoni Sports & Cultural Foundation',
      title: 'About Team || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'mission-vission', component: MissionVissionComponent,
    data: {
      keywords: 'Mission Vission ||  G H Raisoni Sports & Cultural Foundation',
      description: 'Mission Vission ||  G H Raisoni Sports & Cultural Foundation',
      title: 'Mission Vission || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'zankar-lavani', component: ZankarLavaniComponent,
    data: {
      keywords: ' Zankar Lavani ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Zankar Lavani ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Zankar Lavani || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-open-tournament', component: ChessOpenTournamentComponent,
    data: {
      keywords: ' Chess Open Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Chess Open Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Chess Open Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'jalna-chess-tournament', component: JalnaChessTournamentComponent,
    data: {
      keywords: ' Jalna Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Jalna Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Jalna Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'twenty-eigth-nationals-chess-championship', component: TwentyEigthNationalsChessChampionshipComponent,
    data: {
      keywords: ' Twenty Eigth Nationals Chess Championship ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Twenty Eigth Nationals Chess Championship ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Twenty Eigth Nationals Chess Championship || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'jalna-open-chess-tournament', component: JalnaOpenChessTournamentComponent,
    data: {
      keywords: ' Jalna Open Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Jalna Open Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Jalna Open Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-district-chess-tournament', component: NagpurDistrictChessTournamentComponent,
    data: {
      keywords: ' Nagpur District Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Nagpur District Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Nagpur District Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nagpur-district-rapid-blitz-chess', component: NagpurDistrictRapidBlitzChessComponent,
    data: {
      keywords: ' Nagpur District Rapid Blitz Chess ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Nagpur District Rapid Blitz Chess ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Nagpur District Rapid Blitz Chess || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'singrauli-district-chess-tournament', component: SingrauliDistrictChessTournamentComponent,
    data: {
      keywords: ' Singrauli District Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Singrauli District Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Singrauli District Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ratlam-open-rapid-chess-tournament', component: RatlamOpenRapidChessTournamentComponent,
    data: {
      keywords: ' Ratlam Open Rapid Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Ratlam Open Rapid Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Ratlam Open Rapid Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'bhandara-rapid-chess', component: BhandaraRapidChessComponent,
    data: {
      keywords: ' Bhandara Rapid Chess ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Bhandara Rapid Chess ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Bhandara Rapid Chess || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'khairagarh-chess-tournament', component: KhairagarhChessTournamentComponent,
    data: {
      keywords: ' Khairagarh Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Khairagarh Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Khairagarh Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'pune-chess-tournament', component: PuneChessTournamentComponent,
    data: {
      keywords: ' Pune Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Pune Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Pune Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'gwalior-one-day-chess-tournament', component: GwaliorOneDayChessTournamentComponent,
    data: {
      keywords: ' Gwalior One Day Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Gwalior One Day Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Gwalior One Day Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'chess-tournament-chandrapur', component: ChessTournamentChandrapurComponent,
    data: {
      keywords: ' Chess Tournament Chandrapur ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Chess Tournament Chandrapur ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Chess Tournament Chandrapur || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'sambhajinagar-chess-tournament', component: SambhajinagarChessTournamentComponent,
    data: {
      keywords: ' Sambhajinagar Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Sambhajinagar Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Sambhajinagar Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'durg-divisional-chess-tournament', component: DurgDivisionalChessTournamentComponent,
    data: {
      keywords: ' Durg Divisional Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Durg Divisional Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Durg Divisional Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'surajpur-chess-tournament', component: SurajpurChessTournamentComponent,
    data: {
      keywords: ' Surajpur Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Surajpur Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Surajpur Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ambikapur-chess-tournament', component: AmbikapurChessTournamentComponent,
    data: {
      keywords: ' Ambikapur Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      description: ' Ambikapur Chess Tournament ||  G H Raisoni Sports & Cultural Foundation',
      title: ' Ambikapur Chess Tournament || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'katni-fide-chess-tournament', component: KatniFideChessTournamentComponent,
    data: {
      keywords: '1st G H Raisoni Memorial Katni International FIDE Rapid Rating Chess Tournament 2026 || G H Raisoni Sports & Cultural Foundation',
      description: '1st G H Raisoni Memorial Katni International FIDE Rapid Rating Chess Tournament 2026 || G H Raisoni Sports & Cultural Foundation',
      title: 'Katni International FIDE Rapid Rating Chess Tournament 2026 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'ghraisoni-chess-festival', component: GhraisoniChessFestivalComponent,
    data: {
      keywords: ' G H Raisoni Memorial Nagpur Chess Festival - 2026 ||  G H Raisoni Sports & Cultural Foundation',
      description: ' G H Raisoni Memorial Nagpur Chess Festival - 2026 ||  G H Raisoni Sports & Cultural Foundation',
      title: ' G H Raisoni Memorial Nagpur Chess Festival - 2026 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'khargone-badminton', component: KhargoneBadmintonComponent,
    data: {
      keywords: 'Khargone Badminton||  G H Raisoni Sports & Cultural Foundation',
      description: 'Khargone Badminton||  G H Raisoni Sports & Cultural Foundation',
      title: 'Khargone Badminton|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'international-fide-rapid-rating-chess-tournament-pune', component: InternationalFideRapidRatingChessTournamentPuneComponent,
    data: {
      keywords: 'International FIDE Rapid Rating Chess Tournament Pune||  G H Raisoni Sports & Cultural Foundation',
      description: 'International FIDE Rapid Rating Chess Tournament Pune||  G H Raisoni Sports & Cultural Foundation',
      title: 'International FIDE Rapid Rating Chess Tournament Pune|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'nandurbar-chess-tournament', component: NandurbarChessTournamentComponent,
    data: {
      keywords: 'G. H. Raisoni Memorial Open Chess Tournament 2026 Nandurbar||  G H Raisoni Sports & Cultural Foundation',
      description: 'G. H. Raisoni Memorial Open Chess Tournament 2026 Nandurbar||  G H Raisoni Sports & Cultural Foundation',
      title: 'G. H. Raisoni Memorial Open Chess Tournament 2026 Nandurbar|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'maharashtra-state-sub-junior', component: MaharashtraStateSubJuniorComponent,
    data: {
      keywords: 'YONEX-SUNRISE G.H. Raisoni Memorial 2nd Maharashtra State Sub-Junior (U-9, U-11 & U-13) Selection Badminton Tournament 2026||  G H Raisoni Sports & Cultural Foundation',
      description: 'YONEX-SUNRISE G.H. Raisoni Memorial 2nd Maharashtra State Sub-Junior (U-9, U-11 & U-13) Selection Badminton Tournament 2026||  G H Raisoni Sports & Cultural Foundation',
      title: 'YONEX-SUNRISE G.H. Raisoni Memorial 2nd Maharashtra State Sub-Junior (U-9, U-11 & U-13) Selection Badminton Tournament 2026|| G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'yavatmal-district-badminton', component: YavatmalDistrictBadmintonComponent,
    data: {
      keywords: 'GH Raisoni Memorial Yavatmal District Badminton Championship 2026 ||  G H Raisoni Sports & Cultural Foundation',
      description: 'GH Raisoni Memorial Yavatmal District Badminton Championship 2026 ||  G H Raisoni Sports & Cultural Foundation',
      title: 'GH Raisoni Memorial Yavatmal District Badminton Championship 2026 || G H Raisoni Sports & Cultural Foundation'
    }
  },
  {
    path: 'yonex-nagpur-district', component: YonexNagpurDistrictComponent,
    data: {
      keywords: 'GH Raisoni Memorial Yonex Nagpur District Championship 2026 ||  G H Raisoni Sports & Cultural Foundation',
      description: 'GH Raisoni Memorial Yonex Nagpur District Championship 2026 ||  G H Raisoni Sports & Cultural Foundation',
      title: 'GH Raisoni Memorial Yonex Nagpur District Championship 2026 || G H Raisoni Sports & Cultural Foundation'
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
